/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type StayOverTypeEnum =
  (typeof StayOverTypeEnum)[keyof typeof StayOverTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StayOverTypeEnum = {
  HOTEL: 0,
  PRIVATE: 1,
  TRUCK: 2,
} as const;
